<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "ReCollect Detail",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            dtKey: 0,
            key: '',
            title: "ReCollect Detail",
            items: [
                {
                    text: "Finance",
                    href: "/",
                },
                {
                    text: "Automate Collection",
                    href: "/",
                },
            ],

            list: [],

            modalType: '',
            showJsonModal: false,
            fullJsonData: '',
            loadingDetail: false,
            loadingUpload: false,
            clickedItems: {},
        };
    },

    methods: {
        showModal(type, jsonData) {
            this.modalType = type;

            if (type === 'request') {
                const parsedData = JSON.parse(jsonData);
                this.fullJsonData = this.formatRequestTable(parsedData);
            } else {
                this.fullJsonData = JSON.stringify(JSON.parse(jsonData), null, 2); // Pretty print JSON
            }
            
            this.showJsonModal = true;
        },

        formatRequestTable(data) {
            let table = `<table class="table table-bordered"><thead><tr><th>No</th><th>Reference Number</th><th>Items</th><th>Amount</th></tr></thead><tbody>`;

            data.forEach((entry, index) => {
                let items = entry.items.map(item => item.description).join(", ");
                table += `<tr><td>${index+1}</td><td>${entry.refNum}</td><td>${items}</td><td>${entry.amount}</td></tr>`;
            });

            table += `</tbody></table>`;
            return table;
        },

        closeModal() {
            this.showJsonModal = false;
            this.fullJsonData = '';
            this.modalType = '';
        },

        getlist() {
            this.loadingDetail = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL + 'collection/retry/' + this.$route.params.id)
                .then(response => {
                    if (response.data) {
                        this.list = response.data;
                        this.dtKey += 1;
                        this.loadingDetail = false;
                    }
                })
                .finally(() => {
                    this.loadingDetail = false;
                });
        },

        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY hh:mm:ss a')
            }
        },

        runCollection(id) {
            if (this.clickedItems[id]) return; // Prevent running if already clicked

            const result = confirm(`Are you sure to run this collection?`);
            if (result) {
                this.clickedItems[id] = true; // Mark the item as clicked
                this.loadingUpload = true;
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
                axios.get(process.env.VUE_APP_API_BASEURL + 'collection/run/' + id)
                    .then((response) => {
                        alert(response.data.message ?? 'Collection successfully run.');
                        location.reload();
                    })
                    .catch(error => {
                      alert(error.response.data.message ?? 'Something went wrong! Please try again.');
                      this.clickedItems[id] = false; // Reset in case of error
                    })
                    .finally(() => {
                        this.loadingUpload = false;
                    });
            }
        },

        getResponseStatus(response) {
            try {
                const parsedResponse = JSON.parse(response);
                if (!parsedResponse.Status || parsedResponse.Status.length === 0) {
                    return ''; // Return an empty string if Status is missing or empty
                }

                return parsedResponse.Status.includes("201") ? "Success" : "Fail";
            } catch (error) {
                return ''; // Return an empty string if there's an error parsing the response
            }
        },
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
    },

    mounted() {
        this.getlist();
    },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="live-preview">
          <div class="row align-items-center g-12">
            <div class="col-lg-12">
              <div class="pt-4">
                <h4 class="card-title">Collection File Batch Listing</h4>
              </div>
              <div v-if="loadingDetail">
                <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive">
                  <DataTable
                    :options="{lengthChange: false}"
                    :key="dtKey"
                    class="table table-striped table-nowrap mb-0"
                    id="example"
                  >
                    <thead class="table-secondary">
                      <tr>
                        <th>No.</th>
                        <th>Request</th>
                        <th>Response</th>
                        <th>Status</th> <!-- New column for status -->
                        <th>Batch</th>
                        <th>Run</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(item, index) in list"
                        :key="index"
                        class="content"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a href="#" @click.prevent="showModal('request', item.request)">
                            View Request
                          </a>
                        </td>
                        <td>
                          <a href="#" @click.prevent="showModal('response', item.response)">
                            View Response
                          </a>
                        </td>
                        <td>{{ getResponseStatus(item.response) }}</td> <!-- New column displaying Success/Fail -->
                        <td>{{ item.batch_id }}</td>
                        <td>
                          <template v-if="item.job_dispatched_at === null && JSON.parse(item.request).length > 0">
                            <button
                                v-if="!item.batch_id && !clickedItems[item.id]"
                                @click="runCollection(item.id)"
                                class="btn btn-primary btn-sm"
                            >
                                            Run
                            </button>
                          </template>
                          <template v-else>
                              {{ format_date(item.job_dispatched_at) }}
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showJsonModal" class="modal fade show" tabindex="-1" role="dialog" style="display: block;" aria-modal="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalType }}</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-html="fullJsonData"></div> <!-- Render the table -->
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
                </div>
            </div>
        </div>
    </div>

  </Layout>
</template>
